import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>

      <MantineProvider
        theme={{ fontFamily: "Prompt, sans-serif", defaultRadius: "sm" }}
        defaultColorScheme="light"
      >
        <Notifications position="top-right" zIndex={2077} />
        <App />
      </MantineProvider>

    
  </React.StrictMode>
);
reportWebVitals();
